import { render, staticRenderFns } from "./trainingHome.vue?vue&type=template&id=c79c88b2&scoped=true&"
import script from "./trainingHome.vue?vue&type=script&lang=js&"
export * from "./trainingHome.vue?vue&type=script&lang=js&"
import style0 from "./trainingHome.vue?vue&type=style&index=0&id=c79c88b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79c88b2",
  null
  
)

export default component.exports